import suid from '../../services/suid';

export default {
    name: 'KsTooltipKvm',
    data() {
        return {
            timer: null,
            uuid: ''
        };
    },
    props: {
        toolTipClass: {
            type: String,
            default: ''
        },
        contentClass: {
            type: String,
            default: ''
        },
        position:{
            type: String,
            default: 'auto'
        },
        outHolder: {
            type: Boolean,
            default: true
        }
    },
    mounted() {
        var me = this; 
        this.$nextTick(() => {
            me.uuid = suid('kec-tooltip');
            $(document).on('click', me.closeMe).on('kec-tooltip-click',  me.closeMe);
        })
    },
    destroyed() {
        var me = this;
        this._mouseoutHandler(true);
        // $(document).off('click', me.closeMe).off('kec-tooltip-click', me.closeMe);
    },
    methods: {
        closeMe(e, data) {
            if (data === this.uuid || $.trim($(this.$refs.trans).html()).length <= 0) {
                return;
            }
            let trans = this.$refs.trans;
            let transBox = this.$refs.transBox;
            $(trans).hide();
            this.$nextTick(() => {
                transBox.appendChild(trans);
            });
        },
        _mouseoverHandler(fromMark) {
            if(!fromMark) {
                return;
            }
            clearTimeout(this.timer);
            if (fromMark && $.trim($(this.$refs.trans).html()).length > 0) {
                document.body.appendChild(this.$refs.trans);
                $(this.$refs.trans).show();
                setTimeout(() => {
                    let mark = this.$refs.mark;
                    let offset = $(mark).offset();
                    let width = $(mark).outerWidth();
                    let height = $(mark).outerHeight();
                    offset.top += height;
                    console.log(this.position)
                    if(this.position == 'auto') {
                        if (offset.top + $(this.$refs.trans).height() > $(window).height()) {
                            offset.top = offset.top - height * 3 / 2 - $(this.$refs.trans).height() - 5;// - document.body.scrollHeight;
                        }
                    } else if (this.position == 'top') {
                        offset.top = offset.top - height * 3 / 2 - $(this.$refs.trans).height() - 5;
                    }
                    
                    $(this.$refs.trans).css(offset);
                }, 0);
            }
        },

        _mouseoutHandler(outHolder) {
            if(!outHolder) {
                return;
            }
            if($.trim($(this.$refs.trans).html()).length > 0) {
                let trans = this.$refs.trans;
                let transBox = this.$refs.transBox;
                this.timer = setTimeout(() => {
                    $(trans).hide();
                    this.$nextTick(() => {
                        transBox.appendChild(trans);
                    });
                }, 0);
            }
        },
    }
}